module.exports = __webpack_public_path__ + "img/kid_second-desktop.f6759859.svg";